(function () {
  'use strict';
  document.querySelectorAll('.announcement-bar__track').forEach((track) => {
    const items = track.querySelectorAll('.announcement-bar__item');
    if (items.length < 2) return;
    const bar = track.closest('.announcement-bar');
    const speed = (parseFloat(bar.dataset.autoplay) || 5) * 1000;
    if (!bar.dataset.autoplay) return;
    let index = 0;
    setInterval(() => {
      items[index].hidden = true;
      items[index].setAttribute('aria-hidden', 'true');
      index = (index + 1) % items.length;
      items[index].hidden = false;
      items[index].setAttribute('aria-hidden', 'false');
    }, speed);
  });
})();
